/* eslint-disable @web-monorepo/no-css-file-imports */
import "extended-proptypes/lib/extend-from-standalone";
import "react-flexbox-layout/lib/styles.css";
import "src/stylesheets/normalize.css";
import "src/stylesheets/transitions.css";
import "src/stylesheets/base.css";
import useOnFirstRender from "@classdojo/web/hooks/useOnFirstRender";
import { ClassNames } from "@classdojo/web/nessie/stylingLib";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import GroupsDisplayContainer from "src/pods/groups/components/GroupsDisplayContainer";
import IdeasDisplayContainer from "src/pods/ideas/components/IdeasDisplayContainer";
import DirectionsDisplayContainer from "src/pods/list/components/DirectionsDisplayContainer";
import NoiseDisplayContainer from "src/pods/noise/components/NoiseDisplayContainer";
import PairShareResultContainer from "src/pods/pairshare/components/receiver/PairShareResultContainer";
import RadioDisplayContainer from "src/pods/radio/components/RadioDisplayContainer";
import { RandomDisplayContainer } from "src/pods/random/components/RandomDisplayContainer";
import TimerDisplayContainer from "src/pods/timer/components/TimerDisplayContainer";
import TodayResultContainer from "src/pods/today/components/receiver/TodayResultContainer";
import "react-toastify/dist/ReactToastify.css";
import { metrics } from "src/utils/metrics";
import { Helmet } from "react-helmet";

export default function ToolkitAppDisplay() {
  // this tells i18next to load these namespaces
  const { ready } = useTranslation(["dojo.toolkit", "dojo.common"]);

  const params = useParams();

  let Component;
  if (params.app === "pairshare" || params.app === "pairShare") {
    Component = PairShareResultContainer;
  } else if (params.app === "today") {
    Component = TodayResultContainer;
  } else if (params.app === "list" || params.app === "directions") {
    Component = DirectionsDisplayContainer;
  } else if (params.app === "timer") {
    Component = TimerDisplayContainer;
  } else if (params.app === "radio") {
    Component = RadioDisplayContainer;
  } else if (params.app === "noise") {
    Component = NoiseDisplayContainer;
  } else if (params.app === "random") {
    Component = RandomDisplayContainer;
  } else if (params.app === "groups") {
    Component = GroupsDisplayContainer;
  } else if (params.app === "ideas") {
    Component = IdeasDisplayContainer;
  } else {
    throw new Error(`Invalid app: ${params.app}`);
  }

  useOnFirstRender(() => {
    metrics.increment(`display.${params.app}.open`);
  });

  return (
    <>
      <Helmet>
        <script src="https://static.classdojo.com/radiant-media-player/js/rmp.min.js" key="rmp" />
      </Helmet>
      <body>
        <ClassNames>
          {({ css }) => (
            <ToastContainer
              position="top-center"
              autoClose={3500}
              hideProgressBar={true}
              newestOnTop={false}
              closeOnClick
              rtl={false}
              draggable
              pauseOnHover
              closeButton={false}
              sx={{ width: "fit-content" }}
              // we pass toast a component, not a string to fully control UI. this css removes some default background
              toastClassName={css({ background: "none", boxShadow: "none" })}
            />
          )}
        </ClassNames>

        {ready && <Component />}
      </body>
    </>
  );
}
